import StatusBadge from './StatusBadge';

const PurchaseOrdersWidget = ({ orders = [], loading, onViewAll, isAdmin = false }) => {
  if (loading) {
    return (
      <div className="glass metric-card">
        <h5>📦 Purchase Orders</h5>
        {[1, 2, 3].map(i => <div key={i} className="placeholder-line" style={{ height: '2.5rem', marginBottom: '0.5rem' }} />)}
      </div>
    );
  }

  if (orders.length === 0) {
    if (!isAdmin) return null;
    return (
      <div className="glass metric-card">
        <h5>📦 Purchase Orders</h5>
        <p className="home-chart-empty">No purchase orders found</p>
      </div>
    );
  }

  return (
    <div className="glass metric-card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
        <h5 style={{ margin: 0 }}>📦 Purchase Orders</h5>
        {onViewAll && (
          <button className="home-view-all-btn" onClick={onViewAll}>
            View All →
          </button>
        )}
      </div>
      <div className="home-po-table">
        {orders.slice(0, 5).map((po, i) => (
          <div key={po.id || i} className="home-po-row">
            <span className="home-po-number">{po.poNumber || `PO-${po.id}`}</span>
            <span className="home-po-supplier">{po.supplierName || po.supplier || '—'}</span>
            <span className="home-po-amount">
              {po.currency || '$'}{po.total?.toLocaleString?.() || po.totalAmount?.toLocaleString?.() || '—'}
            </span>
            <StatusBadge status={po.status} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PurchaseOrdersWidget;
